import { ReactNode, useState } from "react";

interface TooltipProps {
  content: string;
  children: ReactNode;
  disabled?: boolean;
}

const Tooltip = ({ content, children, disabled = false }: TooltipProps) => {
  const [isVisible, setIsVisible] = useState(false);

  if (!content || disabled) {
    return <>{children}</>;
  }

  return (
    <div
      className="relative inline-block w-full"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <div className="absolute bottom-full left-1/2 z-50 mb-2 -translate-x-1/2 transform">
          <div className="whitespace-nowrap rounded-lg bg-gray-900 px-3 py-2 text-sm text-white shadow-lg">
            {content}
            <div className="absolute left-1/2 top-full -translate-x-1/2 transform border-4 border-transparent border-t-gray-900" />
          </div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
